export default {
  common: {
    adminFunction: "Administrator function",
    accountManagement: "Account management",
    accountPermission: "Management account & permission",
    regionManagement: "Region management",
    zoneCountryCity: "Update zone, country & city",
    cityWeatherManagement: "City weather data",
    weatherProfileBaseOnCity: "Update weather profile base on city",
    ecatDataManagement: "Catalog data management",
    ecatLibraryEquipmentsModels: "Catalog library equipments & models",
    cancel: "Cancel",
    save: "Save"
  },
  account: {
    inputUserName: "Input E-mail",
    thereAreNoMoreUsersLeft: "There are no more users left.",
    superAdmin: "Super Administrator",
    global: "Global",
    region: "Region",
    regional: "Regional",
    zoneCountry: "Zone/Country",
    city: "City",
    segmentMegaCity: "Segment(Mega city)",
    status: "Status",
    activeStatus: "Active status",
    role: "Role",
    active: "Active",
    inactive: "Inactive",
    fillRole: "Please select a role"
  }
}



// WEBPACK FOOTER //
// ./src/locale/admin/en.js